//#region src/constants.ts
const DEFAULT_PORT = 8969;
const SERVER_IDENTIFIER = "spotlight-by-sentry";
const CONTEXT_LINES_ENDPOINT = "/contextlines";
const RAW_TYPES = new Set([
	"attachment",
	"replay_video",
	"statsd"
]);

//#endregion
export { CONTEXT_LINES_ENDPOINT, DEFAULT_PORT, RAW_TYPES, SERVER_IDENTIFIER };
//# sourceMappingURL=constants-GZCtrBU_.js.map